// Order Insight mock data for drawer

export const getOrderInsight = (orderId: string): Record<string, any> => {
  const insights: Record<string, any> = {
    'ORD-8901': {
      orderId: 'ORD-8901',
      marketplaceOrderId: 'AMZ-402-7891234-8901',
      marketplace: 'Amazon',
      channel: 'Amazon.in',
      store: 'TechVault India',
      workspaceId: 'WS-TV-0891',
      status: 'Shipped',
      placedAt: '2026-01-09T08:22:00Z',
      payment: 'Prepaid',
      gross: 2490,
      netEstimate: 2018,
      riskScore: 'Low',
      slaAge: '2h 12m',
      customer: { name: 'R***a K***r', city: 'Bengaluru', state: 'Karnataka', country: 'India' },
      items: [
        { sku: 'SKU-TV-001', masterSku: 'CAN-EP-001', name: 'Wireless Earbuds Pro', qty: 1, price: 1490, tax: 268, discount: 0, mappingStatus: 'Mapped', inventoryAvailable: 234 },
        { sku: 'SKU-TV-009', masterSku: 'CAN-EC-012', name: 'Earbuds Carry Case', qty: 1, price: 1000, tax: 180, discount: 448, mappingStatus: 'Mapped', inventoryAvailable: 89 },
      ],
      fulfillment: {
        courier: 'Delhivery',
        awb: 'DEL****8901',
        status: 'In Transit',
        steps: [
          { label: 'Pickup Scheduled', done: true, time: '2026-01-09T10:00:00Z' },
          { label: 'Picked Up', done: true, time: '2026-01-09T14:30:00Z' },
          { label: 'In Transit', done: true, time: '2026-01-09T18:00:00Z' },
          { label: 'Out for Delivery', done: false, time: null },
          { label: 'Delivered', done: false, time: null },
        ],
        shipBy: '2026-01-10T23:59:00Z',
        deliveryEta: '2026-01-12T18:00:00Z',
        address: '42, M***n R**d, Koramangala, Bengaluru, KA 560034',
        exceptions: [],
      },
      fees: {
        grossTotal: 2490,
        shipping: 0,
        marketplaceCommission: 224,
        paymentGatewayFee: 49,
        taxes: 448,
        netPayout: 2018,
      },
      issues: [
        { id: 'iss-1', severity: 'INFO', title: 'SKU mapping verified', description: 'All items in this order have verified canonical mappings.', suggestedAction: 'No action required.', resolved: true },
      ],
      timeline: [
        { time: '2026-01-09T08:22:00Z', event: 'Order Received', source: 'Amazon' },
        { time: '2026-01-09T08:23:00Z', event: 'Inventory Reserved', source: 'SmartStore' },
        { time: '2026-01-09T08:25:00Z', event: 'Invoice Generated', source: 'SmartStore' },
        { time: '2026-01-09T10:00:00Z', event: 'Manifest Created', source: 'SmartStore' },
        { time: '2026-01-09T14:30:00Z', event: 'Shipped', source: 'Delhivery' },
      ],
      healthChecks: [
        { label: 'Inventory reserved', status: 'ok' },
        { label: 'Address complete', status: 'ok' },
        { label: 'SKU mapping valid', status: 'ok' },
        { label: 'Fraud signals', status: 'ok' },
      ],
      insightChips: [],
    },
    'ORD-8902': {
      orderId: 'ORD-8902',
      marketplaceOrderId: 'FK-OD-567890123',
      marketplace: 'Flipkart',
      channel: 'Flipkart.com',
      store: 'TechVault India',
      workspaceId: 'WS-TV-0891',
      status: 'Processing',
      placedAt: '2026-01-09T11:45:00Z',
      payment: 'COD',
      gross: 1890,
      netEstimate: 1512,
      riskScore: 'Medium',
      slaAge: '5h 30m',
      customer: { name: 'S***h P***l', city: 'Ahmedabad', state: 'Gujarat', country: 'India' },
      items: [
        { sku: 'SKU-TV-002', masterSku: 'CAN-HB-002', name: 'USB-C Hub 7-in-1', qty: 1, price: 1890, tax: 340, discount: 0, mappingStatus: 'Needs Review', inventoryAvailable: 12 },
      ],
      fulfillment: {
        courier: 'Ekart',
        awb: 'EKT****2345',
        status: 'Pickup Pending',
        steps: [
          { label: 'Pickup Scheduled', done: true, time: '2026-01-09T12:00:00Z' },
          { label: 'Picked Up', done: false, time: null },
          { label: 'In Transit', done: false, time: null },
          { label: 'Out for Delivery', done: false, time: null },
          { label: 'Delivered', done: false, time: null },
        ],
        shipBy: '2026-01-10T18:00:00Z',
        deliveryEta: '2026-01-13T18:00:00Z',
        address: '15, S***r N***r, Satellite, Ahmedabad, GJ 380015',
        exceptions: [{ type: 'warning', message: 'Courier pickup pending > 6h — may miss SLA' }],
      },
      fees: {
        grossTotal: 1890,
        shipping: 49,
        marketplaceCommission: 189,
        paymentGatewayFee: 0,
        taxes: 340,
        netPayout: 1512,
      },
      issues: [
        { id: 'iss-2', severity: 'WARNING', title: 'SKU mapping needs review', description: 'SKU-TV-002 canonical mapping has low confidence (68%).', suggestedAction: 'Review mapping in Catalog > Mapping Review.', resolved: false },
        { id: 'iss-3', severity: 'BLOCKER', title: 'Inventory sync degraded', description: 'Flipkart inventory sync last ran 18h ago. Stock may be stale.', suggestedAction: 'Trigger manual sync from Catalog > Sync Center.', resolved: false },
        { id: 'iss-4', severity: 'INFO', title: 'COD order', description: 'Cash on Delivery — payout after delivery confirmation.', suggestedAction: 'Standard flow, no action needed.', resolved: true },
      ],
      timeline: [
        { time: '2026-01-09T11:45:00Z', event: 'Order Received', source: 'Flipkart' },
        { time: '2026-01-09T11:46:00Z', event: 'Inventory Reserved', source: 'SmartStore' },
        { time: '2026-01-09T11:50:00Z', event: 'Invoice Generated', source: 'SmartStore' },
        { time: '2026-01-09T12:00:00Z', event: 'Manifest Created', source: 'SmartStore' },
      ],
      healthChecks: [
        { label: 'Inventory reserved', status: 'warn' },
        { label: 'Address complete', status: 'ok' },
        { label: 'SKU mapping valid', status: 'warn' },
        { label: 'Fraud signals', status: 'ok' },
      ],
      insightChips: ['Low stock SKU', 'COD high-risk region'],
    },
    'ORD-8906': {
      orderId: 'ORD-8906',
      marketplaceOrderId: 'FK-OD-567890456',
      marketplace: 'Flipkart',
      channel: 'Flipkart.com',
      store: 'TechVault India',
      workspaceId: 'WS-TV-0891',
      status: 'Returned',
      placedAt: '2026-01-07T09:10:00Z',
      payment: 'Prepaid',
      gross: 2100,
      netEstimate: -180,
      riskScore: 'High',
      slaAge: '2d 8h',
      customer: { name: 'A***d M***a', city: 'Mumbai', state: 'Maharashtra', country: 'India' },
      items: [
        { sku: 'SKU-TV-006', masterSku: null, name: 'Webcam 1080p', qty: 1, price: 2100, tax: 378, discount: 0, mappingStatus: 'Needs Review', inventoryAvailable: 0 },
      ],
      fulfillment: {
        courier: 'Ekart',
        awb: 'EKT****6789',
        status: 'Returned',
        steps: [
          { label: 'Pickup Scheduled', done: true, time: '2026-01-07T10:00:00Z' },
          { label: 'Picked Up', done: true, time: '2026-01-07T15:00:00Z' },
          { label: 'In Transit', done: true, time: '2026-01-07T20:00:00Z' },
          { label: 'Delivered', done: true, time: '2026-01-08T14:00:00Z' },
          { label: 'Return Initiated', done: true, time: '2026-01-08T18:00:00Z' },
        ],
        shipBy: '2026-01-08T23:59:00Z',
        deliveryEta: '2026-01-10T18:00:00Z',
        address: '78, B***a R**d, Andheri West, Mumbai, MH 400058',
        exceptions: [{ type: 'error', message: 'Customer initiated return — reason: "Product not as described"' }],
      },
      fees: {
        grossTotal: 2100,
        shipping: 0,
        marketplaceCommission: 210,
        paymentGatewayFee: 42,
        taxes: 378,
        netPayout: -180,
      },
      issues: [
        { id: 'iss-5', severity: 'BLOCKER', title: 'Return in progress', description: 'Customer returned this order. Refund processing.', suggestedAction: 'Wait for return inspection. Escalate if > 7 days.', resolved: false },
        { id: 'iss-6', severity: 'WARNING', title: 'SKU mapping missing', description: 'Webcam 1080p has no canonical master SKU mapping.', suggestedAction: 'Map SKU in Catalog > Mapping Review.', resolved: false },
        { id: 'iss-7', severity: 'WARNING', title: 'Out of stock', description: 'This SKU has 0 inventory. Listing may be deactivated.', suggestedAction: 'Restock or pause listing.', resolved: false },
      ],
      timeline: [
        { time: '2026-01-07T09:10:00Z', event: 'Order Received', source: 'Flipkart' },
        { time: '2026-01-07T09:11:00Z', event: 'Inventory Reserved', source: 'SmartStore' },
        { time: '2026-01-07T09:15:00Z', event: 'Invoice Generated', source: 'SmartStore' },
        { time: '2026-01-07T10:00:00Z', event: 'Manifest Created', source: 'SmartStore' },
        { time: '2026-01-07T15:00:00Z', event: 'Shipped', source: 'Ekart' },
        { time: '2026-01-08T14:00:00Z', event: 'Delivered', source: 'Ekart' },
        { time: '2026-01-08T18:00:00Z', event: 'Return Initiated', source: 'Flipkart' },
      ],
      healthChecks: [
        { label: 'Inventory reserved', status: 'fail' },
        { label: 'Address complete', status: 'ok' },
        { label: 'SKU mapping valid', status: 'fail' },
        { label: 'Fraud signals', status: 'warn' },
      ],
      insightChips: ['High return probability', 'SKU mapping missing'],
    },
  };

  // Fallback: generate a generic insight for any order not explicitly defined
  if (insights[orderId]) return insights[orderId];

  return {
    orderId,
    marketplaceOrderId: `MKT-${orderId.replace('ORD-', '')}`,
    marketplace: 'Amazon',
    channel: 'Amazon.in',
    store: 'TechVault India',
    workspaceId: 'WS-TV-0891',
    status: 'Shipped',
    placedAt: '2026-01-08T10:00:00Z',
    payment: 'Prepaid',
    gross: 1650,
    netEstimate: 1320,
    riskScore: 'Low',
    slaAge: '1d 4h',
    customer: { name: 'J***n D***e', city: 'Delhi', state: 'Delhi', country: 'India' },
    items: [
      { sku: 'SKU-GEN-001', masterSku: 'CAN-GEN-001', name: 'Generic Product', qty: 1, price: 1650, tax: 297, discount: 0, mappingStatus: 'Mapped', inventoryAvailable: 56 },
    ],
    fulfillment: {
      courier: 'BlueDart',
      awb: 'BD****0001',
      status: 'In Transit',
      steps: [
        { label: 'Pickup Scheduled', done: true, time: '2026-01-08T12:00:00Z' },
        { label: 'Picked Up', done: true, time: '2026-01-08T16:00:00Z' },
        { label: 'In Transit', done: true, time: '2026-01-08T20:00:00Z' },
        { label: 'Out for Delivery', done: false, time: null },
        { label: 'Delivered', done: false, time: null },
      ],
      shipBy: '2026-01-09T23:59:00Z',
      deliveryEta: '2026-01-11T18:00:00Z',
      address: '12, C***l P***e, New Delhi, DL 110001',
      exceptions: [],
    },
    fees: { grossTotal: 1650, shipping: 40, marketplaceCommission: 165, paymentGatewayFee: 33, taxes: 297, netPayout: 1320 },
    issues: [],
    timeline: [
      { time: '2026-01-08T10:00:00Z', event: 'Order Received', source: 'Amazon' },
      { time: '2026-01-08T10:01:00Z', event: 'Inventory Reserved', source: 'SmartStore' },
      { time: '2026-01-08T10:05:00Z', event: 'Invoice Generated', source: 'SmartStore' },
      { time: '2026-01-08T12:00:00Z', event: 'Manifest Created', source: 'SmartStore' },
      { time: '2026-01-08T16:00:00Z', event: 'Shipped', source: 'BlueDart' },
    ],
    healthChecks: [
      { label: 'Inventory reserved', status: 'ok' },
      { label: 'Address complete', status: 'ok' },
      { label: 'SKU mapping valid', status: 'ok' },
      { label: 'Fraud signals', status: 'ok' },
    ],
    insightChips: [],
  };
};
